"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var VideoPlay = function (props) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { viewBox: "0 0 32 32", children: (0, jsx_runtime_1.jsx)("path", { d: "M10.6667 9.09333V22.9067C10.6667 23.96 11.8267 24.6 12.7201 24.0267L23.5734 17.12C24.4001 16.6 24.4001 15.4 23.5734 14.8667L12.7201 7.97333C11.8267 7.4 10.6667 8.04 10.6667 9.09333Z", fill: "currentColor" }) })));
};
exports.VideoPlay = VideoPlay;
